/*
create by BaiZhiming 2016-2-23
*/
'use strict';

angular
    .module('manageCfg.roleManageMent.permissionAssignment', [
        'manageCfg.roleManageMent.permissionAssignmentRouter',
        'manageCfg.roleManageMent.permissionAssignment.SavePerModule',
        'manageCfg.roleManageMent.permissionAssignment.editingCenter',
        'manageCfg.roleManageMent.permissionAssignment.modulePermission',
        'manageCfg.roleManageMent.permissionAssignment.proRange',
        'manageCfg.roleManageMent.permissionAssignment.orgRange',
        'manageCfg.roleManageMent.permissionAssignment.plCenterCommandModule',
        'manageCfg.roleManageMent.permissionAssignment.usermanage',
        'manageCfg.roleManageMent.permissionAssignment.plCenterLargeScreenModule',
        'manageCfg.roleManageMent.permissionAssignment.resourceCenter',
        'manageCfg.roleManageMent.permissionAssignment.operationcenter',
        'moduleVisibilityModule',
        'manageCfg.roleManageMent.permissionAssignment.authorityTemplateModule',
        'trsPermissionModule',
        'wangchaPermissionModule',
    ])
    .controller('permissionAssignmentCtrl', [
        '$scope',
        '$q',
        '$rootScope',
        '$timeout',
        '$modal',
        '$state',
        'modalDialog',
        'trsHttpService',
        'localStorageService',
        function($scope, $q, $rootScope, $timeout, $modal, $state, modalDialog, trsHttpService, localStorageService) {
            /**
             * [initStatus getRealGroupObj] 初始化状态
             * @return {[type]} [description] obj
             */
            function initStatus() {
                $scope.status = {
                    operationCenterIndex: 0,
                };
                $scope.data = {
                    moduleList: [],
                };
                // $state.go("manageconfig.rolemanage.permissionassignment.default");
                $scope.$on('roleData', function(event, data) {
                    if (data.ROLEID === '1') {
                        // 如果是系统管理员角色，不能设置权限
                        $state.go('manageconfig.rolemanage');
                        return;
                    }
                    if ($scope.status.tab === 'editingCenter') {
                        getEditingCenterProduct();
                    }
                });
                $scope.$on('savePermissionSuccess', function() {
                    getEditingCenterProduct();
                });
            }

            /**
             * [initData getRealGroupObj] 初始化数据
             * @return {[type]} [description] obj
             */
            function initData() {
                $scope.selectPMTab('resourceCenter', '资源中心');
            }

            /**
             * [selectPMTab description] 切换模块
             * @param   {[type]}  module      [module description]
             * @param   {[type]}  moduleName  [moduleName description]
             * @return  {[type]}              [return description]
             */
            $scope.selectPMTab = function(module, moduleName) {
                $scope.status.selectedProduct = '';
                $scope.status.tab = module;
                $scope.status.selectedModule = module;
                $scope.status.moduleName = moduleName;
                $state.go('manageconfig.rolemanage.permissionassignment');
                switch ($scope.status.selectedModule) {
                    case 'design':
                        getPlanningCenterProduct();
                        break;
                    case 'editorial':
                        getEditingCenterProduct();
                        break;
                    case 'resource':
                        getResourceCenterProduct();
                        break;
                    case 'visualCenter':
                        break;
                    case 'research':
                        getOperationCenterList();
                        break;
                    case 'cloud':
                        getCloudMarketList();
                        break;
                    case 'configmodule':
                        getManageConfigList();
                        break;
                }
            };

            /**
             * [privilegeTaking] 特权取稿
             * @return {[type]} [description] obj
             */
            $scope.privilegeTaking = function() {
                $scope.status.selectedProduct = 'privilegeTaking';
                $state.go('manageconfig.rolemanage.permissionassignment.privilegetaking');
            };

            /**
             * [getResourceCenterProduct] 获取资源中心产品列表
             * @return {[type]} [description] obj
             */
            function getResourceCenterProduct() {
                $scope.data.resourceCenter = [
                    {
                        moduleName: '资源中心',
                        key: 'resourcecenter',
                    },
                ];
                getResourceMaterial();
                $scope.resChooseModule($scope.data.resourceCenter[0]);
            }

            /**
             * [getResourceMaterial description] 获取资源中心素材库一级权限
             * @return  {[type]}  [return description]
             */
            function getResourceMaterial() {
                var params = {
                    serviceid: 'mlf_extrole',
                    methodname: 'queryRightClassifys',
                    Classify: 'source',
                };
                trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then((data) => {
                    data.splice(0, 1); // 第一层的资源中心不需要
                    $scope.data.resourceMaterial = data;
                });
            }

            /**
             * [resChooseModule description] 选择资源中心模块
             * @param   {[type]}  module  [module description]
             * @return  {[type]}          [return description]
             */
            $scope.resChooseModule = function(module) {
                $scope.status.selectedProduct = module.MEDIANAME;
                var params = {
                    type: module.moduleName || module.MEDIANAME,
                };
                $state.go('manageconfig.rolemanage.permissionassignment.resourcecenter', params, {
                    reload: 'manageconfig.rolemanage.permissionassignment.resourcecenter',
                });
            };

            /**
             * [getPlanningCenterProduct] 获取策划中心产品列表
             * @return {[type]} [description] obj
             */
            function getPlanningCenterProduct() {
                requestPlanningCenterProduct().then(function(data) {
                    $scope.data.plCenterMedias = data;
                    $scope.selectPlCenterNode(data[0].CHILDREN[0], 0, data[0]);
                });
            }

            /**
             * [requestPlanningCenterProduct description]
             * @return  {[type]}  [return description]
             */
            function requestPlanningCenterProduct() {
                var deffer = $q.defer();
                var params = {
                    serviceid: 'mlf_extrole',
                    methodname: 'queryPlanMediaProduct',
                    RoleId: $scope.roleData.ROLEID,
                };
                $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function(data) {
                    deffer.resolve(data);
                });
                return deffer.promise;
            }

            /**
             * [description] 策划中心权限保存成功后向外通知刷新策划中心产品列表
             */
            $scope.$on('planCtrRightSuccess', function() {
                requestPlanningCenterProduct().then(function(data) {
                    $scope.data.plCenterMedias = data;
                });
            });

            /**
             * [selectPlCenterNode] 点击策划中心模块授权
             * @return {[type]} [description] obj
             */
            $scope.selectPlCenterNode = function(node, index, media) {
                $scope.status.selectedProduct = node.MODALNAME + node.OBJID;
                $rootScope.plCenterRight = {
                    chooseNode: angular.copy(node),
                    treeData: angular.copy($scope.data.plCenterMedias),
                    treeIndex: index,
                    media: angular.copy(media),
                };
                $state.go('manageconfig.rolemanage.permissionassignment.plCCommand', '', {
                    reload: 'manageconfig.rolemanage.permissionassignment.plCCommand',
                });
            };

            /**
             * [getEditingCenterProduct] 获取创作分发产品列表
             * @return {[type]} [description] obj
             */
            function getEditingCenterProduct() {
                var params = {
                    serviceid: 'mlf_extrole',
                    methodname: 'queryMediaProductsTree',
                    RoleId: $scope.roleData.ROLEID,
                };
                $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function(data) {
                    $scope.data.medias = data;
                });
            }

            /**
             * [setEditingCenterPermission] 创作分发产品选择
             * @return {[type]} [description] obj
             */
            $scope.setEditingCenterPermission = function(siteId, siteDesc, mediaType, classify, channelId, accountId) {
                $scope.status.selectedProduct = siteDesc + (siteId ? siteId : channelId ? channelId : accountId);
                localStorageService.set('setEditingCenterPermission', {
                    siteId: siteId,
                    siteDesc: siteDesc,
                    moduleName: $scope.status.moduleName,
                    mediaType: mediaType,
                    CLASSIFY: classify,
                    channelId: channelId,
                    accountId: accountId, // 微博ID
                });
                var url = 'manageconfig.rolemanage.permissionassignment.' + classify;
                $state.go(url, '', { reload: url });
            };

            /**
             * [getOperationCenterList] 获取运营中心产品列表
             * @return {[type]} [description] obj
             */
            function getOperationCenterList() {
                $scope.data.operationCenterList = [];
                $scope.data.operationCenterList.push({
                    name: '运营中心',
                    routeName: 'index',
                    type: 'index',
                });
                // }
                if ($scope.data.operationCenterList.length > 0) {
                    $scope.operationChooseModule($scope.data.operationCenterList[0], 0);
                }
            }


            /**
             * [resChooseModule]  获取指定考核系统单元下的考核部门集合
             * @return {[type]} [description] obj
             */
            /**
             * [resChooseModule] 选择运营中心产品列表
             * @return {[type]} [description] obj
             */
            $scope.operationChooseModule = function(module, index) {
                $scope.status.selectedProduct = module.type;
                var router = 'manageconfig.rolemanage.permissionassignment.' + module.routeName;
                $state.go(router, '', { reload: router });
            };
            $scope.chooseCMProduct = function(item) {
                $scope.status.selectedProduct = 'cloudmarket';
                $state.go('manageconfig.rolemanage.permissionassignment.' + item.key, '', {
                    reload: 'manageconfig.rolemanage.permissionassignment.' + item.key,
                });
            };
            function getCloudMarketList() {
                $scope.data.cloudMarketList = [
                    {
                        name: '网察大数据',
                        key: 'wangchabigdata',
                    },
                ];
                $scope.chooseCMProduct($scope.data.cloudMarketList[0]);
            }

            /**
             * [getManageConfigList] 获取管理配置产品
             * @return {[type]} [description] obj
             */
            function getManageConfigList() {
                var params = {
                    serviceid: 'mlf_metadataright',
                    methodname: 'queryTypesOfConfigmodule',
                };
                $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function(data) {
                    $scope.data.manageConfig = data;
                    $scope.chooseModule(data[0]);
                });
            }

            /**
             * [setIwoPermission] 设置iwo权限
             * @return {[type]} [description] obj
             */
            $scope.setIwoPermission = function(media) {
                if (media.CLASSIFY === 'iwo') {
                    $scope.status.selectedProduct = media.CLASSIFY;
                    localStorageService.set('setEditingCenterPermission', media);
                    $scope.$emit('switchSite', '');
                    // 同路径下切换通知开始
                    $timeout(function() {
                        $state.go('manageconfig.rolemanage.permissionassignment.iwo', '', {
                            reload: 'manageconfig.rolemanage.permissionassignment.iwo',
                        });
                    }, 500);
                    // 同路径下切换通知结束
                }
            };

            /**
             * [chooseModule] 选择模块
             * @return {[type]} [description] obj
             */
            $scope.chooseModule = function(module) {
                $scope.status.selectedProduct = module.TYPE;
                $state.go('manageconfig.rolemanage.permissionassignment.' + module.TYPE, '', {
                    reload: 'manageconfig.rolemanage.permissionassignment.' + module.TYPE,
                });
            };
            initStatus();
            queryMlfModule().then(function(data){
                initData();
            })

            /**
             * [initStatus queryMlfModule] 获取模块
             * @param {string} [roleId] [description] 角色ID
             * @return {[type]} [description] null
             */
            function queryMlfModule() {
                var deffer = $q.defer();
                var params = {
                    serviceid: 'mlf_modal',
                    methodname: 'queryMlfModal',
                    RoleId: $scope.roleData.ROLEID,
                };
                $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function(data) {
                    var commonModuleData = angular.copy(data);
                    $scope.data.moduleList = commonModuleData;
                    deffer.resolve();
                });
                return deffer.promise;
            }
        },
    ]);
